var i=()=>n,n=(t,...e)=>t;export{i as a};
